'use strict';

module.exports = function (position, event) {

  // console.log('currentRow=>' + position[0])
  // console.log('currentCol=>' + position[1])

  this.$set(this.opts.currentCell, 'row', position[0]);
  this.$set(this.opts.currentCell, 'column', position[1]);
  this.$set(this.opts.currentCell, 'columnName', this.columns[position[1]]);

  // console.log('this.opts.currentCell=>' + this.opts.currentCell.row)
  // console.log('this.opts.currentCell=>' + this.opts.currentCell.column)
  // console.log('this.opts.currentCell.columnName =>' + this.opts.currentCell.columnName)
};


// WEBPACK FOOTER //
// ./src/components/vuetable-2-kernel/compiled/methods/column-position.js